import React, { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { ZONES } from "../utils/constants";
import "./AllEventsPage.css";

export default function AllEventsPage() {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [filters, setFilters] = useState({
    project: "",
    zone: "",
    location: "",
    gameCode: "",
    endingCode: "",
    date: "",
    note: "",
  });

  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [customFilterOpen, setCustomFilterOpen] = useState(false);

  const navigate = useNavigate();

  // 🚀 Firestore’dan veriyi al + ilk yüklemede Bugün & Yarın uygula
  useEffect(() => {
    const q = query(collection(db, "events"), orderBy("date", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setEvents(data);

      // İlk açılışta otomatik bugün + yarın filtrele
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      const format = (d) => d.toISOString().split("T")[0];

      const filtered = data.filter(
        (ev) => ev.date === format(today) || ev.date === format(tomorrow)
      );

      setFilteredEvents(filtered);
    });

    return () => unsub();
  }, []);

  // 📄 PDF EXPORT
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Events Report", 14, 20);

    let y = 30;

    filteredEvents.forEach((ev) => {
      doc.setFontSize(12);
      doc.text(`Project: ${ev.project}`, 14, y); y += 6;
      doc.text(`Zone: ${ev.zone}`, 14, y); y += 6;
      doc.text(`Location: ${ev.location}`, 14, y); y += 6;
      doc.text(`Date: ${ev.date}`, 14, y); y += 6;
      doc.text(`Game Code: ${ev.gameCode || "-"}`, 14, y); y += 6;
      doc.text(`Ending Code: ${ev.endingCode || "-"}`, 14, y); y += 6;
      doc.text(`Note: ${ev.note || "-"}`, 14, y); y += 8;

      doc.line(14, y, 195, y);
      y += 10;

      if (y > 270) {
        doc.addPage();
        y = 20;
      }
    });

    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");

    const fileName = `ACM-Games-Schedule_${now.getFullYear()}-${pad(
      now.getMonth() + 1
    )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
      now.getMinutes()
    )}.pdf`;

    doc.save(fileName);
  };

  const [projectList, setProjectList] = useState([]);
  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("name", "asc"));

    const unsub = onSnapshot(q, (snap) => {
      const list = snap.docs.map((d) => d.data().name); // sadece name alanı
      setProjectList(list);
    });

    return () => unsub();
  }, []);



  // 📥 Excel Export (Sadece filtreli liste)
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredEvents);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FilteredEvents");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf]), "FilteredEvents.xlsx");
  };

  // 📌 TODAY & TOMORROW FILTER
  const applyTodayTomorrow = () => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const format = (d) => d.toISOString().split("T")[0];

    setFilteredEvents(
      events.filter(
        (ev) => ev.date === format(today) || ev.date === format(tomorrow)
      )
    );

    setFilterMenuOpen(false);
  };

  // 🔄 SHOW ALL
  const showAll = () => {
    setFilteredEvents(events);
    setFilterMenuOpen(false);
  };

  // 🎛 APPLY CUSTOM FILTERS
  const applyCustomFilter = () => {
    setFilteredEvents(
      events.filter((ev) => {
        return (
          ev.project.toLowerCase().includes(filters.project.toLowerCase()) &&
          ev.zone.toLowerCase().includes(filters.zone.toLowerCase()) &&
          ev.location.toLowerCase().includes(filters.location.toLowerCase()) &&
          (ev.gameCode || "").toLowerCase().includes(filters.gameCode.toLowerCase()) &&
          (ev.endingCode || "").toLowerCase().includes(filters.endingCode.toLowerCase()) &&
          ev.date.includes(filters.date) &&
          (ev.note || "").toLowerCase().includes(filters.note.toLowerCase())
        );
      })
    );
    setCustomFilterOpen(false);
  };

  // 🎨 Modal CSS Objeleri
  const modalBackdrop = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  };



  const miniModal = {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    width: "85%",
    maxWidth: "380px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
    textAlign: "center",
    position: "relative",
  };

  const bigModal = {
    background: "#fff",
    padding: 20,
    borderRadius: 10,
    width: 450,
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
  };

  const filterGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "12px",
    padding: "10px 0",
  };

  const greenBtn = {
    background: "#28a745",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
  };

  const redBtn = {
    background: "#dc3545",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
  };

  const grayBtn = {
    background: "#6c757d",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
  };

  const yellowBtn = {
    background: "#ffc107",
    color: "#000",
    padding: "8px 16px",
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
  };
  const dropdownStyle = {
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #ccc",
    background: "#fff",
    fontSize: "14px",
  };


  const inputStyle = {
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: "14px",
  };

  const selectDisabledStyle = {
    ...dropdownStyle,
    background: "#e9ecef",
  };
  const filterButtonContainer = {
    display: "flex",
    flexDirection: window.innerWidth < 600 ? "column" : "row",
    gap: "12px",
    marginTop: "12px",
  };


  return (
<div className="all-events-wrapper">

      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
        <h3>📋 All Events</h3>
          <button
    onClick={() => navigate(-1)}
    className="back-btn"
  >
    ⬅
  </button>
      </div>

      

      {/* EXPORT BUTTONS */}
      {events.length > 0 && (
        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <button style={greenBtn} onClick={exportExcel}>📥 Export Excel</button>
          <button style={redBtn} onClick={exportPDF}>📄 Export PDF</button>
          <button style={yellowBtn} onClick={() => setFilterMenuOpen(true)}>🔍 Filter</button>
        </div>
      )}

      {/* 📌 KÜÇÜK FİLTRE MENÜ MODALI */}
      {filterMenuOpen && (
        <div
          style={modalBackdrop}
          onClick={() => setFilterMenuOpen(false)}  // DIŞ TIKLAMA → KAPAT
        >
          <div
            style={miniModal}
            onClick={(e) => e.stopPropagation()}  // İçeri tıklayınca kapanmasın
          >
            <button
              onClick={() => setFilterMenuOpen(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                border: "none",
                background: "transparent",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ✖
            </button>

            <h3>FILTER OPTIONS</h3>

            <div style={filterButtonContainer}>
              <button style={greenBtn} onClick={applyTodayTomorrow}>
                📅 Today & Tomorrow
              </button>

              <button
                style={yellowBtn}
                onClick={() => {
                  setFilterMenuOpen(false);
                  setCustomFilterOpen(true);
                }}
              >
                🎛 Custom Filter
              </button>

              <button style={grayBtn} onClick={showAll}>
                🔄 Show All
              </button>
            </div>
          </div>
        </div>
      )}


      {/* 🎛 CUSTOM FILTER MODALI */}
      {customFilterOpen && (
        <div style={modalBackdrop}>
          <div style={bigModal}>

            <h3>Custom Filter</h3>

            <div style={filterGrid}>

              {/* Project Dropdown */}
              <select
                value={filters.project}
                onChange={(e) => setFilters({ ...filters, project: e.target.value })}
                style={dropdownStyle}
              >
                <option value="">All Projects</option>
                {projectList.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>

              {/* Zone Dropdown */}
              <select
                value={filters.zone}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    zone: e.target.value,
                    location: "", // zone değişince location sıfırlansın
                  })
                }
                style={dropdownStyle}
              >
                <option value="">All Zones</option>
                {Object.keys(ZONES).map((zone) => (
                  <option key={zone} value={zone}>
                    {zone}
                  </option>
                ))}
              </select>

              {/* Location Dropdown → Seçilen Zone’a göre */}
              <select
                value={filters.location}
                onChange={(e) =>
                  setFilters({ ...filters, location: e.target.value })
                }
                style={dropdownStyle}
                disabled={!filters.zone}
              >
                <option value="">All Locations</option>
                {filters.zone &&
                  ZONES[filters.zone].map((loc) => (
                    <option key={loc} value={loc}>
                      {loc}
                    </option>
                  ))}
              </select>

              {/* Game Code */}
              <input
                placeholder="Game Code"
                style={inputStyle}
                value={filters.gameCode}
                onChange={(e) =>
                  setFilters({ ...filters, gameCode: e.target.value })
                }
              />

              {/* Ending Code */}
              <input
                placeholder="Ending Code"
                style={inputStyle}
                value={filters.endingCode}
                onChange={(e) =>
                  setFilters({ ...filters, endingCode: e.target.value })
                }
              />

              {/* Date */}
              <input
                type="date"
                style={inputStyle}
                value={filters.date}
                onChange={(e) => setFilters({ ...filters, date: e.target.value })}
              />

              {/* Note Contains */}
              <input
                placeholder="Note"
                style={inputStyle}
                value={filters.note}
                onChange={(e) => setFilters({ ...filters, note: e.target.value })}
              />

            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
              <button style={greenBtn} onClick={applyCustomFilter}>Apply</button>
              <button style={redBtn} onClick={() => setCustomFilterOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}


{/* TABLE */}
<div
  className="table-container"
  style={{
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "auto",
    width: "100%",
  }}
>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>

    {/* HEADER */}
    <thead
      style={{
        position: "sticky",
        top: 0,
        background: "white",
        zIndex: 30,
      }}
    >
      <tr>
        <th>
          Project
        </th>
        <th>Zone</th>
        <th>Location</th>
        <th>Type</th>
        <th>Game Code</th>
        <th>Ending Code</th>
        <th>Date</th>
        <th>Note</th>
      </tr>
    </thead>

    {/* BODY */}
    <tbody>
  {filteredEvents.map((e) => (
    <tr
      key={e.id}
      style={{
        background: e.isReality ? "#f8f9fa" : "#fff",
        fontWeight: e.isReality ? 700 : 400,
      }}
    >
      <td>{e.project}</td>

      <td>{e.zone || "-"}</td>
      <td>{e.location || "-"}</td>

      {/* 🔥 TYPE KOLONU */}
      <td>
        {e.isReality ? (
          <span
            style={{
              background: "#000",
              color: "#fff",
              padding: "2px 8px",
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            🎬 REALITY
          </span>
        ) : (
          <span
            style={{
              background: "#0d6efd",
              color: "#fff",
              padding: "2px 8px",
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            🎮 GAME
          </span>
        )}
      </td>

      <td>{e.gameCode || "-"}</td>
      <td>{e.endingCode || "-"}</td>
      <td>{e.date}</td>
      <td>{e.note || "-"}</td>
    </tr>
  ))}
</tbody>


  </table>
</div>


    </div>
  );
}
